var PNotify = require("pnotify");
// load pnotify modules (I'm using only these two)
require("pnotify/src/pnotify.buttons.js");
require("pnotify/src/pnotify.confirm.js");
export var PNotify = PNotify;